import { Menu, Transition } from "@headlessui/react";
import { Fragment } from "react";
import logo_only from "../../../assets/logo-Innovia.png";

import { MdAddModerator, MdOutlineLogout } from "react-icons/md";
import Loading from "../loading/Loading";
import { RoutePath } from "../../../utility/Constant";
import { Link } from "react-router-dom";
import { HiOutlineUsers } from "react-icons/hi";
import { GiHamburgerMenu } from "react-icons/gi";


export default function NavMenu({ user, loading, handleSignOut }) {
  const { userList } = RoutePath;
  const links = [
    {
      title: "All users",
      url: userList,
      icon: <HiOutlineUsers className="mr-2 h-5 w-5" aria-hidden="true" />,
    },
  ];

  return (
    <div>
      <Menu as="div" className="relative inline-block text-left">
       <Menu.Button className="bg-white font-bold w-11 h-11 flex items-center justify-center p-1 rounded-full overflow-hidden">
  {loading ? (
    <Loading />
  ) : (
    <GiHamburgerMenu className="h-[22px] w-[22px] text-red-600" />
  )}
</Menu.Button>

        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className="absolute z-30 right-0 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
            {user?.role === "admin" && (
              <div className="p-2">
                {links.map((link) => (
                  <Menu.Item key={link.title}>
                    {({ active }) => (
                      <Link to={`/${link.url}`}>
                        <button
                          className={`${
                            active ? "" : ""
                          } group flex w-full items-center rounded-md px-2 py-2 text-base font-medium text-gray-900 hover:bg-green-100 hover:text-[#DB0029]`}
                        >
                          {link.icon}
                          {link.title}
                        </button>
                      </Link>
                    )}
                  </Menu.Item>
                ))}
              </div>
            )}
            <div className="p-2">
              <Menu.Item>
                {({ active }) => (
                  <button
                    onClick={handleSignOut}
                    className={`${
                      active ? "" : ""
                    } group flex w-full items-center rounded-md px-2 py-2 text-base font-medium text-gray-900 hover:text-red-500 hover:bg-red-100`}
                  >
                    {active ? (
                      <MdOutlineLogout
                        className="mr-2 h-5 w-5"
                        aria-hidden="true"
                      />
                    ) : (
                      <MdOutlineLogout
                        className="mr-2 h-5 w-5"
                        aria-hidden="true"
                      />
                    )}
                    Log out
                  </button>
                )}
              </Menu.Item>
            </div>
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  );
}
